import { createApi } from "@reduxjs/toolkit/query/react";
import axiosBaseQuery from "./axiosBaseQuery";
import { SLS_URL } from "../../Config/slsConfig";
import {
  InputUserUpdate,
  OutputUserUpdate,
  OutputWhoAmi,
} from "../../Services/Serverless/Users/users.interface";

export const UserApi = createApi({
  reducerPath: "userApi",
  baseQuery: axiosBaseQuery({ baseUrl: SLS_URL }),
  tagTypes: ["User"],
  endpoints: (builder) => ({
    whoami: builder.query<OutputWhoAmi, { token: string }>({
      query: ({ token }) => ({
        url: "/users/whoami",
        method: "POST",
        headers: { Authorization: `Bearer ${token}` },
      }),
      providesTags: ["User"],
    }),
    updateUser: builder.mutation<
      OutputUserUpdate,
      { data: InputUserUpdate; token: string }
    >({
      query: ({ data, token }) => ({
        url: "/users/update",
        method: "POST",
        headers: { Authorization: `Bearer ${token}` },
        data: data,
      }),
      invalidatesTags: ["User"],
    }),
  }),
});

export const { useWhoamiQuery, useUpdateUserMutation } = UserApi;
